export const ADVERSE_EVENTS_PREFIX = 'AdverseEvents_Information_';
export const SPECIAL_SITUATIONS_PREFIX = 'SpecialSituations_Information_';
export const CONTACT_US_PREFIX = 'ContactUs_Information_';

export const INFO_BUTTON_IO_CONFIG_PREFIXES_AND_DATA_TYPE = {
  [ADVERSE_EVENTS_PREFIX] : 'text',
  [SPECIAL_SITUATIONS_PREFIX]: 'table',
  [CONTACT_US_PREFIX]: 'text',
};
